import { AlertTriangle, Clock, CheckCircle2 } from 'lucide-react';

interface Props {
  deadline: string | null | undefined;
  label?: string;
  className?: string;
}

/**
 * Colour-coded chip for a Part 1 deadline.
 *   red   — past due or <30 days away
 *   amber — <90 days away
 *   green — plenty of time
 *   grey  — no deadline set (no first-sale date on the cultivar)
 */
export default function DeadlineChip({ deadline, label = 'Part 1 due', className = '' }: Props) {
  if (!deadline) {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs bg-neutral-100 text-neutral-500 ${className}`}>
        <Clock className="h-3 w-3" />
        No deadline
      </span>
    );
  }
  const target = new Date(deadline);
  const now = new Date();
  const ms = target.getTime() - now.getTime();
  const days = Math.ceil(ms / (1000 * 60 * 60 * 24));

  let style = 'bg-emerald-100 text-emerald-700';
  let Icon: typeof Clock = CheckCircle2;
  let suffix = `${days} days`;

  if (days < 0) {
    style = 'bg-red-100 text-red-700';
    Icon = AlertTriangle;
    suffix = `${-days} days overdue`;
  } else if (days <= 30) {
    style = 'bg-red-100 text-red-700';
    Icon = AlertTriangle;
  } else if (days <= 90) {
    style = 'bg-amber-100 text-amber-700';
    Icon = Clock;
  }

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${style} ${className}`}>
      <Icon className="h-3 w-3" />
      {label}: {deadline} ({suffix})
    </span>
  );
}
